import { HeaderBalance } from '#/components/HeaderBalance/HeaderBalance';
import { cx, isWhiteLabelMode } from '@streamster/shared/utils';
import React, { MouseEventHandler, ReactNode, useContext } from 'react';
import logo from '@streamster/shared/assets/img/logoName.png';
import { navigationRef } from '@streamster/shared/navigation/navigation.ref';
import { AuthContext } from '@streamster/shared/screens/auth/auth.utils';
import { SocketContext } from '@streamster/shared/socket/socket.provider';
import { ToasterContext } from '@streamster/shared/toaster/toaster.provider';
import Button from '@streamster/shared/components/Button/Button';
import { useMobileWebAppStore } from '../WebNavigation/mobileAppWeb.store';
import './styles.scss';

export const WebLayout: React.FC<{ children?: ReactNode }> = ({ children }) => {
  const { logout, isAuth, isAccountActive, resendVerificationEmail } = useContext(AuthContext);
  const { success, error } = useContext(ToasterContext);
  const { cleanServerData } = useContext(SocketContext);
  const { isMobileWebApp } = useMobileWebAppStore();
  const isWhiteLabel = isWhiteLabelMode();

  const onLogoClick: React.MouseEventHandler = e => {
    e.preventDefault();

    navigationRef.current?.reset({
      routes: [{ name: 'Home' }],
    });
  };

  const handleLogout = () => {
    cleanServerData();
    logout();
  };

  const handleResendVerificationEmail: MouseEventHandler<HTMLAnchorElement> = e => {
    e.preventDefault();

    resendVerificationEmail()
      .then(() => success({ message: 'Verification link has been resent' }))
      .catch(err => error({ message: err.message }));
  };

  const inactiveAccBannerVisible = isAuth && !isAccountActive();

  return (
    <div id="layout" className={cx(isAuth && 'logged-in', isWhiteLabel && 'whitelabel')}>
      <header
        className={cx(inactiveAccBannerVisible && 'with-banner', isWhiteLabel && 'whitelabel')}
      >
        {isWhiteLabel ? (
          <div></div>
        ) : (
          <>
            {isAuth ? (
              <a href="https://app.streamster.io" onClick={onLogoClick}>
                <img src={logo} />
              </a>
            ) : (
              <a href={isMobileWebApp ? undefined : 'https://streamster.io'}>
                <img src={logo} />
              </a>
            )}
          </>
        )}
        {inactiveAccBannerVisible ? (
          <p className="account-inactive">
            Please confirm your email address.{' '}
            <a href="#" onClick={handleResendVerificationEmail}>
              Resend the verification e-mail
            </a>
          </p>
        ) : null}
        {isAuth && (
          <>
            <HeaderBalance />
            <Button secondary onPress={handleLogout}>
              Log out
            </Button>
          </>
        )}
      </header>
      <main>
        <div className="content">{children}</div>
      </main>
    </div>
  );
};
